import TabOptions from '../options';

import vocationalEvaluationOptionTypes from '@/utils/constants/vocationalEvaluationOptionTypes';

export class Model {}
export class Tab {
  id = 'Two';
  title = 'II';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    const options = model?.options || [];
    const psychosocialHistoryOrigins = options.filter(
      (x) =>
        x?.type?.id ===
          vocationalEvaluationOptionTypes.OrigenHistorialPsicosocial &&
        x?.checked
    );

    return {
      tab: this.id,
      personalContextInfo: model.personalContextInfo ?? null,
      academicInfo: model.academicInfo ?? null,
      healthHistory: model.healthHistory ?? null,
      workAndVolunteerExperience: model.workAndVolunteerExperience ?? null,
      additionalRelevantInfo: model.additionalRelevantInfo ?? null,
      psychosocialHistoryOriginIds: psychosocialHistoryOrigins.map((x) => x.id),
    };
  };
}
export default new Tab();
